module.exports = {
  endpoint: process.env.REACT_APP_URL_API,
  endpointWs: process.env.REACT_APP_URL_WS,
  supabaseId: process.env.REACT_APP_SUPABASE_ID,
  supabaseKeyAnon: process.env.REACT_APP_SUPABASE_KEY_ANON,
  supabaseKeyAdmin: process.env.REACT_APP_SUPABASE_KEY_ADMIN,
};
